// src/features/urlaubsplaner/hooks/useUrlaub.ts

import { useState, useEffect, useCallback } from 'react';
import { StaffUrlaubMitName, UrlaubFormData } from '../types';
import { urlaubService } from '../services/urlaubService';

export const useUrlaub = (monat: number, jahr: number) => {
  const [abwesenheiten, setAbwesenheiten] = useState<StaffUrlaubMitName[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const ladeAbwesenheiten = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const daten = await urlaubService.getAbwesenheitenFuerMonat(monat, jahr);
      setAbwesenheiten(daten);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Fehler beim Laden');
    } finally {
      setLoading(false);
    }
  }, [monat, jahr]);

  useEffect(() => {
    ladeAbwesenheiten();
  }, [ladeAbwesenheiten]);

  const erstelleAbwesenheit = async (formData: UrlaubFormData): Promise<{ success: boolean; error?: string }> => {
    const result = await urlaubService.erstelleAbwesenheit(formData);
    if (result.success) {
      await ladeAbwesenheiten();
    }
    return result;
  };

  const aktualisiereAbwesenheit = async (id: string, formData: UrlaubFormData): Promise<{ success: boolean; error?: string }> => {
    const result = await urlaubService.aktualisiereAbwesenheit(id, formData);
    if (result.success) {
      await ladeAbwesenheiten();
    }
    return result;
  };

  const loescheAbwesenheit = async (id: string): Promise<{ success: boolean; error?: string }> => {
    const result = await urlaubService.loescheAbwesenheit(id);
    if (result.success) {
      await ladeAbwesenheiten();
    }
    return result;
  };

  return {
    abwesenheiten,
    loading,
    error,
    ladeAbwesenheiten,
    erstelleAbwesenheit,
    aktualisiereAbwesenheit,
    loescheAbwesenheit
  };
};
